import { Box, Fab, Grid, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router";

import { useEffect, useState } from "react";

import {
  setUserDetail,
  setbillerMenuseletected,
  setbusinessChooseTab,
} from "../app/store/reducer";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router/dist";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import PersonIcon from "@mui/icons-material/Person";
import StorefrontIcon from "@mui/icons-material/Storefront";
import TableBarIcon from "@mui/icons-material/TableBar";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import SearchIcon from "@mui/icons-material/Search";
import HandshakeIcon from "@mui/icons-material/Handshake";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { routePath } from "../constants/routePath";
import LogOutPop from "./logoutPop";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { capitalizeFirstLetter } from "../app/common/commonFunction";
export default function BillingBarSide() {
  const navigate = useNavigate();
  const headerMenu = useSelector((state) => state.reducer.headerMenu);
  const [header1, setHeader1] = useState([]);
  const [header2, setHeader2] = useState([]);

  // const arrN = (urlHeaderMenu) => {
  //   let arr1 = [...header1];

  //   let arr2 = [...header2];

  //   if (arr1.length == 0) {
  //     urlHeaderMenu.forEach((element, index) => {
  //       if (index % 2 == 0) {
  //         arr1.push(element);
  //       } else {
  //         arr2.push(element);
  //       }
  //       setHeader1(arr1);
  //       setHeader2(arr2);
  //     });
  //   }
  // };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const iconsObj = {
    PersonIcon: PersonIcon,
    StorefrontIcon: StorefrontIcon,
    TableBarIcon: TableBarIcon,
    TableRestaurantIcon: TableRestaurantIcon,
    SearchIcon: SearchIcon,
    HandshakeIcon: HandshakeIcon,
    DashboardIcon: DashboardIcon,
    CurrencyRupeeOutlinedIcon: CurrencyRupeeOutlinedIcon,
    SettingsOutlinedIcon: SettingsOutlinedIcon,
    LockOutlinedIcon: LockOutlinedIcon,
    HeadsetMicOutlinedIcon: HeadsetMicOutlinedIcon,
    ShareOutlinedIcon: ShareOutlinedIcon,
    LogoutOutlinedIcon: PowerSettingsNewIcon,
  };
  const billerMenuseletec = useSelector(
    (state) => state.reducer.billerMenuseletec
  );
  const billerMenu = useSelector((state) => state.reducer.billerMenu);

  const dispatch = useDispatch();

  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // const indexRoute3 = billerMenu.findIndex(
    //   (it) => it.route === location.pathname
    // );
    // setbillerMenuseletected(indexRoute3);
  }, [location.pathname]);

  return (
    <Grid
      container
      spacing={0}
      sx={{
        position: "sticky",
        top: "104px",
        // background: "#3695b6",
        overflowY: "auto",
        // maxHeight: "calc(100vh - 60px)",

        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        background: "#E3E3FF",
        pl: "5px",
      }}
    >
      <Grid sx={{ height: "auto" }} item md={12}>
        {billerMenu?.map((item, index) => {
          const indexRoute = billerMenu.findIndex(
            (it) => it.systemFuctionName === item.systemFuctionName
          );
          const IconComponent = iconsObj[billerMenu[indexRoute]?.icon];

          return (
            <>
              <Box
                key={"siderbar" + index}
                bgcolor="primary"
                sx={{
                  padding:
                    item.systemFuctionName === "Sign Out" ? "4px" : "10px",

                  // background: billerMenuseletec === index ? "#C0BFFF" : "",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",

                  fontWeight: billerMenuseletec === index ? "500" : "200",
                  fontSize: "12px",
                }}
                onClick={async (e) => {
                  // navigate(item?.route);
                  if (item?.tab?.length > 0) {
                    dispatch(setbusinessChooseTab(item?.tab[0]));
                  }
                  navigate(routePath.COUNTERSELL);

                  dispatch(setbillerMenuseletected(index));
                }}
              >
                <Typography
                  variant="standard"
                  color="#01008B"
                  sx={{
                    fontWeight: billerMenuseletec === index ? 600 : 400,

                    borderBottom:
                      billerMenuseletec === index ? "1px solid #01008B" : "",
                  }}
                >
                  {(function () {
                    const indexRoute = headerMenu.findIndex(
                      (it) => it.systemFuctionName === item.systemFuctionName
                    );

                    return capitalizeFirstLetter(item.systemFuctionName);
                  })()}
                </Typography>
                {/* {item.tab &&
                  (billerMenuseletec === index ? (
                    <ArrowDropDownIcon sx={{ color: "#fff" }} />
                  ) : (
                    <ArrowRightIcon sx={{ color: "#fff" }} />
                  ))} */}
              </Box>
              {billerMenuseletec === index && item.tab && (
                <Box sx={{ display: "block", borderBottom: "1px solid white" }}>
                  {item?.tab?.map((ele, index) => {
                    return (
                      <Box
                        bgcolor="primary"
                        onClick={() => {
                          console.log(" valuevaluevalue ", {
                            value: ele.value,
                          });
                          dispatch(
                            setbusinessChooseTab({
                              value: ele.value,
                              label: ele.label,
                            })
                          );
                        }}
                        sx={{
                          border: "1px solid white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderRadius: "10px",
                          cursor: "pointer",
                          padding: "7px 13px",
                          margin: "8px",
                          background:
                            businessChooseTab?.value == ele.value ? "#fff" : "",
                          transition: "0.3s",
                          boxShadow:
                            businessChooseTab?.value == ele.value
                              ? "1px 4px 3px #0000003d"
                              : "unset",
                        }}
                      >
                        <Typography
                          variant="standard"
                          color={
                            businessChooseTab?.value == ele.value
                              ? "#127093"
                              : "#fff"
                          }
                          textAlign={"left"}
                        >
                          {capitalizeFirstLetter(ele.label)}
                        </Typography>
                        {/* {businessChooseTab?.value == ele.value && (
                          <KeyboardArrowRightIcon sx={{ color: "#127093" }} />
                        )} */}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </>
          );
        })}
      </Grid>
      <LogOutPop open={open} setOpen={setOpen} />
    </Grid>
    // </Box>
  );
}
